import * as React from "react";
import {FormBodyProps} from "../../../../common/props/FormBodyProps";
import Row from "../../../../layout/Row";
import InputFormGroup from "../../../../../hiberUiKit/src/molecules/FormGroup/InputFormGroup";
import Col from "../../../../layout/Col";
import CurrencyInputFormGroup from "../../../../ui/form/CurrencyInputFormGroup";
import BillOfMaterialsAssetForm from "./BillOfMaterialsAssetForm";
import SectionView from "../../../../layout/section/SectionView";
import RangeNumberInputFormGroup from "../../../../ui/form/RangeNumberInputFormGroup";
import {BomItem} from "../../../../../model/job/BomItems";

interface ComponentProps {
	/**
	 * Bill of materials asset to edit.
	 */
	bomAsset: BomItem;
}

type Props = FormBodyProps<BillOfMaterialsAssetForm> & ComponentProps

export default class BillOfMaterialsAssetFormBody extends React.PureComponent<Props> {
	render() {

		const {selfSourced} = this.props.bomAsset
		return (
			<SectionView>
				<Row>
					<Col lg={6} xl={6}>
						<InputFormGroup label="Model"
										placeholder="Enter model"
										field={this.props.form.name}
										onChange={this.props.onFieldChange}
										focus={this.props.form.hasFocus(this.props.form.name)}/>
					</Col>
					{!selfSourced && <Col lg={6} xl={6}>
						<InputFormGroup label="Manufacturer"
										placeholder="Enter manufacturer"
										field={this.props.form.manufacturerName}
										onChange={this.props.onFieldChange}
										focus={this.props.form.hasFocus(this.props.form.manufacturerName)}/>
					</Col>}
				</Row>
				<Row>
					<Col lg={6} xl={6}>
						<CurrencyInputFormGroup label="Sell price (excl. VAT)"
												placeholder="Enter sell price"
												field={this.props.form.sellUnitPrice}
												onChange={this.props.onFieldChange}
												focus={this.props.form.hasFocus(this.props.form.sellUnitPrice)}/>
					</Col>
					{!selfSourced && <Col lg={6} xl={6}>
						<RangeNumberInputFormGroup field={this.props.form.markup}
												   minValue={0}
												   maxValue={100}
												   placeholder={"Enter markup"}
												   onChange={this.props.onFieldChange}
												   label={"Markup (%)"}
												   focus={this.props.form.hasFocus(this.props.form.markup)}/>
					</Col>}
				</Row>
				<Row>
					<Col lg={6} xl={6}>
						<RangeNumberInputFormGroup label="Quantity"
												   placeholder="Enter quantity"
												   field={this.props.form.quantity}
												   onChange={this.props.onFieldChange}
												   minValue={1}
												   maxDecimalPlaces={0}
												   focus={this.props.form.hasFocus(this.props.form.quantity)}/>
					</Col>
					{!selfSourced && <Col lg={6} xl={6}>
						<CurrencyInputFormGroup label="Rebate"
												placeholder="Enter rebate"
												field={this.props.form.rebateUnitPrice}
												onChange={this.props.onFieldChange}
												focus={this.props.form.hasFocus(this.props.form.rebateUnitPrice)}/>
					</Col>}
				</Row>
			</SectionView>
		);
	}
}
